import { CheckCircle2, Download } from 'lucide-react';

import type { RedactionManifest } from '../../types/redaction';

const BRAND_BG = 'bg-emerald-800';

export default function DoneStep({
  manifest,
  recordTitle,
  onDownload,
  onBack,
}: {
  manifest: RedactionManifest;
  /** The record's title, shown in place of the copy's generated file name. */
  recordTitle: string | null;
  onDownload: () => void;
  onBack: () => void;
}) {
  return (
    <div className="px-6 py-12">
      <div className="mx-auto max-w-xl text-center">
        <div className="mx-auto w-fit rounded-full bg-emerald-100 p-3">
          <CheckCircle2 className="h-7 w-7 text-emerald-700" />
        </div>
        <h3 className="mt-4 text-lg font-bold text-gray-900">
          Redacted copy created
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          {manifest.summary.item_count}{' '}
          {manifest.summary.item_count === 1 ? 'item was' : 'items were'} removed
          from {manifest.summary.box_count}{' '}
          {manifest.summary.box_count === 1 ? 'place' : 'places'}, and the copy
          was checked to confirm none of it survived.
        </p>

        <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-left text-sm">
          <p className="font-semibold text-gray-900">
            {recordTitle ?? manifest.file.name}
          </p>
          <p className="mt-1 text-xs text-gray-500">
            Withheld under{' '}
            {manifest.summary.grounds.map((ground) => `s${ground}`).join(', ')}.
          </p>
          <p className="mt-1 text-xs text-gray-500">
            The copy keeps the record's{' '}
            {manifest.information_security_classification?.level ?? 'unclassified'}{' '}
            classification, so it is not more widely accessible than the record
            it came from.
          </p>
        </div>

        {manifest._links?.download?.href && (
          <button
            type="button"
            onClick={onDownload}
            className={`mt-5 flex w-full items-center justify-center rounded-xl px-6 py-3 text-sm font-bold text-white shadow-lg shadow-emerald-200 transition ${BRAND_BG}`}
          >
            <Download className="mr-2 h-4 w-4" />
            Download redacted copy
          </button>
        )}

        <button
          type="button"
          onClick={onBack}
          className="mt-3 w-full rounded-xl border border-gray-200 bg-white px-6 py-3 text-sm font-semibold text-gray-700 transition hover:bg-gray-100"
        >
          Back to record
        </button>
      </div>
    </div>
  );
}
